<div class="container-md">
  <h1 class="text-center">Education Impact Report</h1>
  <div class="row">
      <mat-form-field appearance="outline" class="col-3" >
        <mat-label >Centre Name</mat-label>
        <mat-select  aria-label="Default select example" [(ngModel)]="SelectedCenters" (selectionChange)="onCenterSelectionChange($event)">
          <mat-option  [value]="{centreCode:'All',centreName:'All Centres'}">All</mat-option>
          <mat-option *ngFor="let c of (centres$ | async)" [value]="c">{{c.centreName}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-2">
      <mat-label>Report Type</mat-label>
      <mat-select [(ngModel)]="reportType" >
        <mat-option *ngFor=" let type of reportTypes" [value]="type">{{type}}</mat-option>
      </mat-select>
    </mat-form-field>
      <mat-form-field appearance="outline" class="col-3">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
          <input matEndDate [(ngModel)]="endDate" placeholder="End date">
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-2">
        <mat-label>Submit Type</mat-label>
        <mat-select [(ngModel)]="selectedSubmitType">
          <mat-option value="draft">Draft</mat-option>
          <mat-option value="final">Final</mat-option>
        </mat-select>
      </mat-form-field>
    <div class="col-2">
     <div class="d-flex gap-2">
       <button mat-mini-fab (click)="filterData('')" color="accent" permission="Education Impact Report" [permissionTypes]="[PermissionType.VIEW]">
         <mat-icon>search</mat-icon>
       </button>
       <button mat-mini-fab (click)="clearAll()" color="accent">
         <mat-icon>clear</mat-icon>
       </button>
     </div>
    </div>
  </div>


  <div class="card p-2">
    <div class=" ">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Education Impact Report Table</h2>
          </li>
                  <li class="dropdown m-l-20">
                    <label id="search-input"><i class="material-icons search-icon">search</i></label>
                    <input placeholder="Search" type="text" class="browser-default search-field"
                           (keyup)='applyFilter($event)' aria-label="Search box" #input>
                  </li>
        </ul>
        <ul class="header-buttons ">
          <li class="me-2">
            <button *ngIf="!isExternal"  mat-mini-fab color="primary" permission="Education Impact Report" [permissionTypes]="[PermissionType.ADD]"  (click)="addReport()">
              <mat-icon class="col-white">add</mat-icon>
            </button>&nbsp;&nbsp;
          </li>

          <li>
            <button
              mat-mini-fab color="accent"
              (click)="downloadExcel()">
              <mat-icon>download</mat-icon>
            </button>
          </li>
          <!--        <li>-->
          <!--          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
          <!--            <img src="assets/images/icons/xlsx.png" alt="" />-->
          <!--          </div>-->
          <!--        </li>-->
        </ul>
      </div>

      <table mat-table [dataSource]="filteredDataSource" style="width: 100%" matSort class="body">
        <!-- Define columns -->
        <ng-container matColumnDef="sr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr</th>
          <td mat-cell *matCellDef="let element;let i =index"> {{ i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="childName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre</th>
          <td mat-cell *matCellDef="let element"> {{ element.centreCode }}</td>
        </ng-container>
        <ng-container matColumnDef="totalSessions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Sessions</th>
          <td mat-cell *matCellDef="let element"> {{ element.totalSessions }}</td>
        </ng-container>
        <ng-container matColumnDef="from">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> From</th>
          <td mat-cell *matCellDef="let element"> {{ element.from.toDate() |date:'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="to">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> To</th>
          <td mat-cell *matCellDef="let element"> {{ element.to.toDate()|date:'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
          <td mat-cell *matCellDef="let element"> {{ element.createdAt.toDate()|date:'dd/MM/yyyy hh:mm:aa' }}</td>
        </ng-container>

        <ng-container matColumnDef="submitType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Submit Type</th>
          <td mat-cell *matCellDef="let element"> {{ (element.submitType)|titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="reportType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Report Type</th>
          <td mat-cell *matCellDef="let element"> {{ (element.reportType || 'NA') }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="ViewReportImpact(element.id)" matTooltip="View" color="primary" permission="Education Impact Report" [permissionTypes]="[PermissionType.VIEW]">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button *ngIf="element.submitType=='draft'" permission="Education Impact Report" [permissionTypes]="[PermissionType.EDIT]" matTooltip="Edit"  (click)="ViewReport(element.id)" color="primary">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="deleteReport(element.id)" color="warn" matTooltip="Delete" permission="Education Impact Report" [permissionTypes]="[PermissionType.ARCHIVE]">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <!-- Repeat for other columns -->

        <!-- Render rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <ng-container *ngIf="dataSource.data.length === 0">
        <p class="no-data-message">No data matches the filter. </p>
      </ng-container>
      <mat-paginator *ngIf="dataSource.data" [pageSizeOptions]="[25, 50, 100, 200, 250, 500, 1000]"
                     showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
